import { getUserSession } from '../authentication/helpers/sessionStorage'

const getAuthenticationHeaders = (session = {}, apiKey = '') => {
  const { accessToken = '', xIdToken = '' } = session

  return {
    ...(accessToken && { Authorization: accessToken }),
    ...(xIdToken && { 'x-id-token': xIdToken }),
    ...(apiKey && { 'x-api-key': apiKey }),
  }
}

export const setupInterceptors = (
  axiosInstance,
  { apiKey = '', getSession = getUserSession, onUnauthorized = () => {} } = {},
) => {
  const requestInterceptorId = axiosInstance.interceptors.request.use(
    (requestConfig) => ({
      ...requestConfig,
      headers: {
        ...getAuthenticationHeaders(getSession(), apiKey),
        ...requestConfig.headers,
      },
    }),
    (error) => Promise.reject(error),
  )

  const responseInterceptorId = axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) onUnauthorized(error)
      return Promise.reject(error)
    },
  )

  return () => {
    axiosInstance.interceptors.request.eject(requestInterceptorId)
    axiosInstance.interceptors.response.eject(responseInterceptorId)
  }
}
